import { UserApiKey } from '@iot-platform/models/i4b';
import { createActionGroup, props } from '@ngrx/store';

export const UserApiKeysActions = createActionGroup({
  source: 'UserApiKeys',
  events: {
    'Load User Api Keys': props<{ userId: string }>(),
    'Load User Api Keys Success': props<{ response: UserApiKey[] }>(),
    'Load User Api Keys Failure': props<{ error: unknown }>(),

    'Create User Api Key': props<{ userId: string; userApiKey: UserApiKey }>(),
    'Create User Api Key Success': props<{ response: UserApiKey }>(),
    'Create User Api Key Failure': props<{ error: unknown }>(),

    'Edit User Api Key': props<{ userApiKey: UserApiKey }>(),
    'Edit User Api Key Success': props<{ response: UserApiKey }>(),
    'Edit User Api Key Failure': props<{ error: unknown }>(),

    'Enable User Api Key': props<{ userApiKey: UserApiKey }>(),
    'Enable User Api Key Success': props<{ response: UserApiKey }>(),
    'Enable User Api Key Failure': props<{ error: unknown }>(),

    'Disable User Api Key': props<{ userApiKey: UserApiKey }>(),
    'Disable User Api Key Success': props<{ response: UserApiKey }>(),
    'Disable User Api Key Failure': props<{ error: unknown }>(),

    'Renew User Api Key': props<{ userApiKey: UserApiKey }>(),
    'Renew User Api Key Success': props<{ response: UserApiKey }>(),
    'Renew User Api Key Failure': props<{ error: unknown }>(),

    'Manage User Api Key Usage Plan': props<{ userApiKey: UserApiKey }>(),
    'Manage User Api Key Usage Plan Success': props<{ response: UserApiKey }>(),
    'Manage User Api Key Usage Plan Failure': props<{ error: unknown }>(),

    'Delete User Api Key': props<{ userApiKey: UserApiKey }>(),
    'Delete User Api Key Success': props<{ response: UserApiKey }>(),
    'Delete User Api Key Failure': props<{ error: unknown }>()
  }
});
